export function createBaseGameFormDefaults(overrides = {}) {
  return {
    hostName: "",
    allowedPlayers: 4,
    groupLimit: 4,
    readingTime: 5,
    discussionTime: 10,
    title: "",
    discipline: "",
    codeLanguage: "",
    imageFile: null,
    imageUrl: "",
    imageUploading: false,
    preliminaryReason: true,
    finalReason: true,
    ...overrides,
  };
}

export function createCreateGameFormDefaults() {
  return createBaseGameFormDefaults({
    usersGrade: "",
    originalText: "",
    llm: "Grok",
    inaccuracyLevels: {
      text1: "Medium",
      text2: "Medium",
      text3: "Medium",
    },
    sciArgContent: {
      generalContentArea: "",
      targetAudience: null,
      numberOfClaims: "1",
      claims: [{ claim: "", evidence: "" }],
    },
    sources: {
      text1: "",
      text2: "",
      text3: "",
    },
    realSourceAuthor: "",
    realSourceText: "",
    primarySecondary: {
      text1: "",
      text2: "",
      text3: "",
    },
    manualSourceType: false,
    manualAuthors: false,
    visibility: "private",
  });
}

export function createCopyGameFormDefaults(overrides = {}) {
  return createBaseGameFormDefaults({
    allowedPlayers: null,
    groupLimit: null,
    texts: [],
    realTextId: null,
    realTextLabel: "",
    ...overrides,
  });
}

export function createCopyGameFormFromLoadedGame(gameData) {
  return createCopyGameFormDefaults({
    allowedPlayers: gameData.playerNum,
    groupLimit: gameData.groupLimit,
    readingTime: gameData.readingTime,
    discussionTime: gameData.discussionTime,
    title: gameData.textTitle,
    discipline: gameData.discipline,
    codeLanguage: gameData.codeLanguage,
    imageUrl: gameData.imageUrl || "",
    preliminaryReason: gameData.enablePreliminaryVoteReason,
    finalReason: gameData.enableVoteReason,
    texts: gameData.texts,
    realTextId: gameData.realTextId,
    realTextLabel: gameData.realTextLabel,
  });
}
